import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { formatNumberOneDecimal } from "../../shared/reportUtil";
import { promptScoresReportLink } from "./PromptReport";
import { CrPromptUsage, CrUsageDetails, PromptUsage } from "./PromptUsageFilteredByCourseViewModel";

export function CrPromptAnalysisTable(props: {
	className: string;
	courseId: number;
	promptData: CrPromptUsage[];
	classData: CrUsageDetails;
}) {
	const hasData = props.promptData && props.promptData.length > 0;

	const promptNameTemplate = (rowData: PromptUsage) => {
		return (
			<Link className="link" to={promptScoresReportLink(rowData.promptId, props.courseId)}>
				{rowData.promptName}
			</Link>
		);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right" />
				<Column footer={props.classData.essayCount} footerClassName="font-medium" />
				<Column footer={props.classData.draftCount} footerClassName="font-medium" />
				<Column
					footer={formatNumberOneDecimal(props.classData.averageDraftPerEssay)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.classData.averageScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.promptData}
			dataKey="promptId"
			loading={props.promptData == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Prompt"
				body={promptNameTemplate}
				sortable
				sortField="writerName"></Column>
			<Column header="Number of Essays" field="essayCount" sortable></Column>
			<Column header="Number of Drafts" field="draftCount" sortable></Column>
			<Column header="Avg # of Drafts" field="averageDraftPerEssay" sortable></Column>
			<Column header="Avg Score" field="averageScore" sortable></Column>
		</DataTable>
	);
}
